import React, { useEffect } from "react";
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  useWatch,
} from "react-hook-form";

import FormInputRadio from "components/Form/Input/Radio";
import { ComonObjectType } from "ts/types";
import { checkTruthyValue } from "utils/validation";
import CreditProviders from "./CreditProviders";
import { LABELS } from "./labels";

interface StepProps {
  control: Control<any, any>;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  idKey: string;
  errorKey: ComonObjectType | undefined;
}

const ApplicantCredit: React.FC<StepProps> = ({
  control,
  register,
  setValue,
  idKey,
  errorKey,
}) => {
  const watchExpenditures = useWatch({ name: idKey, control: control });

  // Reset credit providers if not applicantHasOutstandingCredit
  useEffect(() => {
    if (!watchExpenditures) {
      return;
    }
    if (
      !checkTruthyValue(watchExpenditures.applicantHasOutstandingCredit) &&
      (watchExpenditures?.creditProviders?.length || 0) > 0
    ) {
      setValue(`${idKey}.creditProviders`, []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchExpenditures?.applicantHasOutstandingCredit]);

  return (
    <>
      <div className="flex flex-col space-y-4">
        <label className="block text-base font-semibold">
          Outstanding credit
        </label>

        <FormInputRadio
          id={`${idKey}.applicantHasOutstandingCredit`}
          label={LABELS.applicantHasOutstandingCredit}
          register={register}
          requiredField={false}
          initValue={watchExpenditures?.applicantHasOutstandingCredit}
          error={errorKey?.applicantHasOutstandingCredit?.message}
        />

        {checkTruthyValue(watchExpenditures?.applicantHasOutstandingCredit) && (
          <CreditProviders
            setValue={setValue}
            idKey={idKey}
            errorKey={errorKey}
            {...{ control, register }}
          />
        )}
      </div>
    </>
  );
};

export default ApplicantCredit;
